module.exports = __webpack_public_path__ + "video/SAF-700_Ares_SocialEngineeringRedFlags_2025.93f8fd90.vtt";